/**
 * Werk de gebruikersnaam bij van de Firebase user
 * @param {Object} user - Firebase user-object
 * @param {String} displayName - Naam van de gebruiker
 * @returns {Promise<void>}
 */
export const updateUserDisplayName = (user, displayName) => user.updateProfile({displayName});
